import React from "react";
import { Clock, Globe, Car, PawPrint, Phone, Mail, Wifi } from "lucide-react";
import { Button } from "@/components/ui/button";
import { BRAND } from "@/data";
import { EN } from "@/en";

const ICONS = [Clock, Clock, Globe, Car, Wifi, PawPrint];

export default function SejourEn() {
  const t = EN.plan;
  const infos = t.infos.map((it, i) => ({
    ...it,
    icon: ICONS[i],
    value: it.value || (i === 0 ? BRAND.checkin : BRAND.checkout),
  }));
  return (
    <div data-testid="page-plan-en" className="py-20 lg:py-28">
      <div className="max-w-4xl mx-auto px-6 lg:px-10">
        <span className="text-xs font-semibold uppercase tracking-[0.28em] text-terracotta">{t.overline}</span>
        <h1 className="font-serif text-5xl lg:text-6xl font-light mt-5 text-forest">{t.title}</h1>
        <p className="text-charcoal/70 mt-6 text-lg">{t.intro}</p>

        <div className="mt-12 divide-y divide-sand border-y border-sand">
          {infos.map((it) => (
            <div key={it.label} data-testid={`plan-info-${it.label}`} className="flex items-center gap-4 py-5">
              <it.icon className="w-5 h-5 text-forest shrink-0" strokeWidth={1.5} />
              <span className="w-40 text-sm text-charcoal/50">{it.label}</span>
              <span className="text-charcoal/80">{it.value}</span>
            </div>
          ))}
        </div>

        <div className="mt-12 bg-white rounded-2xl border border-sand p-8">
          <h2 className="font-serif text-2xl text-forest">{t.helpTitle}</h2>
          <div className="mt-6 flex flex-wrap gap-3">
            <a href={BRAND.emailLink} data-testid="plan-email"><Button className="rounded-full bg-forest hover:bg-forest-dark text-cream h-11 px-6"><Mail className="mr-2 w-4 h-4" /> {t.email}</Button></a>
            <a href={BRAND.phoneLink} data-testid="plan-phone"><Button variant="outline" className="rounded-full border-forest/30 text-forest hover:bg-forest hover:text-cream h-11 px-6"><Phone className="mr-2 w-4 h-4" /> {t.call}</Button></a>
          </div>
        </div>
      </div>
    </div>
  );
}
